<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <h2>My Saved Lead Searches</h2>
  </ng-template>
  <div class="content">
    <div *ngIf="loading()" class="loading">
      Loading saved searches...
    </div>
    <div *ngIf="error()" class="error">
      {{ error() }}
    </div>
    <div *ngIf="!loading() && !error()" class="saved-searches-list">
      <div *ngIf="savedSearches().length === 0" class="text-center p-4">
        No saved searches found.
      </div>
      <div *ngFor="let search of savedSearches()" class="search-item p-2 hover:bg-surface-100 cursor-pointer" (click)="onSearchClick(search)">
        <div class="flex justify-between items-center">
          <span class="search-name">{{ search.searchName }}</span>
          <span *ngIf="search.default" class="default-badge text-sm text-primary">Default</span>
        </div>
      </div>
    </div>
  </div>
</p-card> 